export default __webpack_public_path__ + "static/media/avatar.106626d1.jpg";